<mat-card appearance="outlined">
  <mat-card-content>
    <h2>{{ 'footer.links.contactUs' | translate }}</h2>
    @if (translate.currentLang == 'fr') {
      <div>
        <p>
          Ordre des dentistes du Québec (ODQ)<br>
          800, boulevard René-Lévesque Ouest, bureau 1640<br>
          Montréal (Québec) H3B 1X9
        </p>
        <p>Téléphone : 514 875-8511<br>
          Ligne sans frais : 1 800 361-4887<br>
          Télécopieur : 514 393-9248
        </p>
        <p>
          Heures d'ouverture : Lundi au vendredi de 8 h 30 à 12 h et de 13 h à 16 h.
        </p>
      </div>
    }
    @if (translate.currentLang == 'en') {
      <div>
        <p>
          Ordre des dentistes du Quebec (ODQ)<br>
          800, René-Lévesque Boulevard West, Bureau 1640<br>
          Montreal (Quebec) H3B 1X9
        </p>
        <p>Phone : 514 875-8511<br>
          Toll-free : 1 800 361-4887<br>
          Fax : 514 393-9248
        </p>
        <p>
          Opening hours : Monday to Friday from 8:30 a.m. to 12:00 and from 1:00 p.m. to 4:00.
        </p>
      </div>
    }
  </mat-card-content>
</mat-card>